import { CommonEnums } from '../../common.enums';

export class Tgt_Attr_Lnk {
    tgt_dObj_Inst_Id: number;
    tgt_dObj_Inst_Attr_Id: number;
    lnk_Obj_Id: number;
    lnk_Obj_Attr_Id: number;
    updKeyFlag: string;
    scdStartDtFlag: string;
    scdEndDtFlag: string;
    currIndFlag: string;
    surrogate_Key: string;
    insert_Column: string;
    update_Column: string;
    scdFlag: string;
    dxMp_Id: number;
    valid_Cd: string;
    tgtAttrNm: string;
    srcAttrNm: string;
    srcDTypNm: string;
    tgtDTypNm: string;
    orderBy: number;
    hashKey: string;
    aiTransformation: string | null;
    aiConfidence: number | null;
    aiReasoningSummary: string | null;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.tgt_dObj_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.tgt_dObj_Inst_Attr_Id = CommonEnums.defaults.LONG_VAL;
        this.lnk_Obj_Id = CommonEnums.defaults.LONG_VAL;
        this.lnk_Obj_Attr_Id = CommonEnums.defaults.LONG_VAL;
        this.updKeyFlag = CommonEnums.defaults.STRING_EMPTY;
        this.scdEndDtFlag = CommonEnums.defaults.STRING_EMPTY;
        this.scdStartDtFlag = CommonEnums.defaults.STRING_EMPTY;
        this.currIndFlag = CommonEnums.defaults.STRING_EMPTY;
        this.surrogate_Key = CommonEnums.defaults.STRING_EMPTY;
        this.insert_Column = CommonEnums.defaults.STRING_EMPTY;
        this.update_Column = CommonEnums.defaults.STRING_EMPTY;
        this.scdFlag = CommonEnums.defaults.STRING_EMPTY;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.tgtAttrNm = CommonEnums.defaults.STRING_EMPTY;
        this.srcAttrNm = CommonEnums.defaults.STRING_EMPTY;
        this.srcDTypNm = CommonEnums.defaults.STRING_EMPTY;
        this.tgtDTypNm = CommonEnums.defaults.STRING_EMPTY;
        this.orderBy = CommonEnums.defaults.LONG_VAL;
        this.hashKey = CommonEnums.defaults.STRING_EMPTY;
        this.aiTransformation = null;
        this.aiConfidence = null;
        this.aiReasoningSummary = null;
    }

    static parse(tgt_Attr_LnkTmp: Tgt_Attr_Lnk): Tgt_Attr_Lnk {
        let tgt_Attr_Lnk: Tgt_Attr_Lnk = new Tgt_Attr_Lnk();
        tgt_Attr_Lnk.copyFrom(tgt_Attr_LnkTmp);
        return tgt_Attr_Lnk;
    }

    getPrimaryKey(): string {
        return this.dxMp_Id + '.' + this.tgt_dObj_Inst_Id + '.' + this.tgt_dObj_Inst_Attr_Id;
    }

    copy(): Tgt_Attr_Lnk {
        let tgt_Attr_LnkTmp: Tgt_Attr_Lnk = new Tgt_Attr_Lnk();

        tgt_Attr_LnkTmp.tgt_dObj_Inst_Id = this.tgt_dObj_Inst_Id;
        tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id = this.tgt_dObj_Inst_Attr_Id;
        tgt_Attr_LnkTmp.lnk_Obj_Id = this.lnk_Obj_Id;
        tgt_Attr_LnkTmp.lnk_Obj_Attr_Id = this.lnk_Obj_Attr_Id;
        tgt_Attr_LnkTmp.updKeyFlag = this.updKeyFlag;
        tgt_Attr_LnkTmp.scdStartDtFlag = this.scdStartDtFlag;
        tgt_Attr_LnkTmp.scdEndDtFlag = this.scdEndDtFlag;
        tgt_Attr_LnkTmp.currIndFlag = this.currIndFlag;
        tgt_Attr_LnkTmp.insert_Column = this.insert_Column;
        tgt_Attr_LnkTmp.surrogate_Key = this.surrogate_Key;
        tgt_Attr_LnkTmp.update_Column = this.update_Column;
        tgt_Attr_LnkTmp.scdFlag = this.scdFlag;
        tgt_Attr_LnkTmp.dxMp_Id = this.dxMp_Id;
        tgt_Attr_LnkTmp.valid_Cd = this.valid_Cd;
        tgt_Attr_LnkTmp.tgtAttrNm = this.tgtAttrNm;
        tgt_Attr_LnkTmp.srcAttrNm = this.srcAttrNm;
        tgt_Attr_LnkTmp.srcDTypNm = this.srcDTypNm;
        tgt_Attr_LnkTmp.tgtDTypNm = this.tgtDTypNm;
        tgt_Attr_LnkTmp.orderBy = this.orderBy;
        tgt_Attr_LnkTmp.hashKey = this.hashKey;
        tgt_Attr_LnkTmp.aiTransformation = this.aiTransformation;
        tgt_Attr_LnkTmp.aiConfidence = this.aiConfidence;
        tgt_Attr_LnkTmp.aiReasoningSummary = this.aiReasoningSummary;

        return tgt_Attr_LnkTmp;
    }

    copyFrom(tgt_Attr_LnkTmp: Tgt_Attr_Lnk): void {
        this.tgt_dObj_Inst_Id = tgt_Attr_LnkTmp.tgt_dObj_Inst_Id;
        this.tgt_dObj_Inst_Attr_Id = tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id;
        this.lnk_Obj_Id = tgt_Attr_LnkTmp.lnk_Obj_Id;
        this.lnk_Obj_Attr_Id = tgt_Attr_LnkTmp.lnk_Obj_Attr_Id;
        this.updKeyFlag = tgt_Attr_LnkTmp.updKeyFlag;
        this.scdStartDtFlag = tgt_Attr_LnkTmp.scdStartDtFlag;
        this.scdEndDtFlag = tgt_Attr_LnkTmp.scdEndDtFlag;
        this.currIndFlag = tgt_Attr_LnkTmp.currIndFlag;
        this.insert_Column = tgt_Attr_LnkTmp.insert_Column;
        this.surrogate_Key = tgt_Attr_LnkTmp.surrogate_Key;
        this.update_Column = tgt_Attr_LnkTmp.update_Column;
        this.scdFlag = tgt_Attr_LnkTmp.scdFlag;
        this.dxMp_Id = tgt_Attr_LnkTmp.dxMp_Id;
        this.valid_Cd = tgt_Attr_LnkTmp.valid_Cd;
        this.tgtAttrNm = tgt_Attr_LnkTmp.tgtAttrNm;
        this.srcAttrNm = tgt_Attr_LnkTmp.srcAttrNm;
        this.srcDTypNm = tgt_Attr_LnkTmp.srcDTypNm;
        this.tgtDTypNm = tgt_Attr_LnkTmp.tgtDTypNm;
        this.orderBy = tgt_Attr_LnkTmp.orderBy;
        this.hashKey = tgt_Attr_LnkTmp.hashKey;
        this.aiTransformation = tgt_Attr_LnkTmp.aiTransformation;
        this.aiConfidence = tgt_Attr_LnkTmp.aiConfidence;
        this.aiReasoningSummary = tgt_Attr_LnkTmp.aiReasoningSummary;
    }

    compare(tgt_Attr_LnkTmp: Tgt_Attr_Lnk): string {
        let tgt_Attr_LnkString: string = this.toString(false);
        let tgt_Attr_LnkTmpString: string = tgt_Attr_LnkTmp.toString(false);

        if (tgt_Attr_LnkString != tgt_Attr_LnkTmpString) {
            return tgt_Attr_LnkString + ', ' + tgt_Attr_LnkTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Tgt_Attr_Lnk [tgt_dObj_Inst_Id=" + this.tgt_dObj_Inst_Id + ", tgt_dObj_Inst_Attr_Id=" + this.tgt_dObj_Inst_Attr_Id +
            ", lnk_Obj_Id=" + this.lnk_Obj_Id + ", lnk_Obj_Attr_Id=" + this.lnk_Obj_Attr_Id + ", updKeyFlag=" + this.updKeyFlag +
            ", scdStartDtFlag=" + this.scdStartDtFlag + ", scdEndDtFlag=" + this.scdEndDtFlag + ", currIndFlag=" + this.currIndFlag +
            ", surrogate_Key=" + this.surrogate_Key + ", insert_Column=" + this.insert_Column + ", update_Column=" + this.update_Column +
            ", scdFlag=" + this.scdFlag + ", dxMp_Id=" + this.dxMp_Id + ", orderBy=" + this.orderBy + ", hashKey=" + this.hashKey + "]";

        if (isNotCompare) {
            str += ", valid_Cd=" + this.valid_Cd + ", tgtAttrNm=" + this.tgtAttrNm + ", srcAttrNm=" + this.srcAttrNm +
                ", srcDTypNm=" + this.srcDTypNm + ", tgtDTypNm=" + this.tgtDTypNm
        }

        str += ']';
        return str;
    }
}
